<template>
  <router-view></router-view>
</template>

<script>
import { uiHelper, locale } from '@/util'
export default {
  name: 'SlotLayout',
  // metaInfo: {
  //   title: `${locale.getMessage('meta.slot_title')}`,
  //   titleTemplate: `%s`,
  //   meta: [{ charset: 'utf-8' }, { name: 'description', content: `${locale.getMessage('meta.slot_description')}` }, { name: 'keyword', content: `${locale.getMessage('meta.slot_keyword')}` }],
  //   link: [
  //     {rel: 'canonical', href: `https://JAYA9.co/slot/`}
  //   ]
  // },
  methods: {
    openLoginDialog() {
      this.$parent.openLoginDialog()
    }
  }
}
</script>
